import {
  createAlbumCardModel,
  createPlaylistCardModel,
  createPlaylistHeroModel,
  createTrackCardModel,
  createTrackListModel,
  createUserCardModel,
} from "../../models/music";

export function mapTrackToCard(track) {
  return createTrackCardModel(track);
}

export function mapUserToCard(user) {
  return createUserCardModel(user);
}

export function mapPlaylistToCard(playlist) {
  return createPlaylistCardModel(playlist);
}

export function mapAlbumToCard(album) {
  return createAlbumCardModel(album);
}

export function mapTrackToListRow(track) {
  return createTrackListModel(track);
}

export function mapPlaylistToHero(playlist) {
  return createPlaylistHeroModel(playlist);
}
